import axios from "../BaseUrl";

export const updateSetting = async (key, value, label) => {
  try {
    const response = await axios.post("/dashboard/settings", { key, value, label });
    return response;
  } catch (err) {
    return err.response;
  }
};
